import { Table } from "../../../../../../components";
import { TableProps } from "antd";
import { useMTPDetailColumns } from "../../hooks";
import { memo, useMemo } from "react";
import { transform } from "../../utils/transform";

export const MTPDetailTable = memo(
  <T extends {}>(props: Partial<TableProps<T>>) => {
    const { dataSource, expandable = {}, ...restTableProps } = props;

    const { columns } = useMTPDetailColumns();

    const data = useMemo(() => transform(dataSource as any[]), [dataSource]);

    const expandableValue = {
      ...expandable,
    };

    return (
      <Table
        {...restTableProps}
        bordered
        expandable={expandableValue as any}
        columns={columns}
        dataSource={data}
        scroll={{ x: 2500 }}
      />
    );
  }
);
